import WarningIcon from '@mui/icons-material/Warning';
import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

import Errors from '../../constants/errors';
import {pxToRem} from '../../utils';

const StyledTypography = styled(Typography)(({theme}) => ({
  marginTop: theme.spacing(1),
  fontWeight: 400,
  '& .MuiSvgIcon-root': {
    fontSize: pxToRem(16),
    verticalAlign: 'middle',
    marginRight: theme.spacing(1),
    lineHeight: 1,
  },
  '&.custom-error-small': {
    fontSize: pxToRem(12),
  },
  '&.custom-error-medium': {
    fontSize: pxToRem(14),
  },
  '&.custom-error-large': {
    fontSize: pxToRem(18),
  },
  '&.custom-error-one': {
    color: theme.palette.error.main,
  },
  '&.custom-error-two': {
    background: theme.palette.error.medium,
    padding: theme.spacing(0.5),
    color: theme.palette.grey[900],
    '& .MuiSvgIcon-root': {
      color: theme.palette.error.main,
    },
  },
}));

function CustomError({message, className = '', size = 'small', styleVariant = 'one'}) {
  const getErrorMessage = () => {
    if (typeof message === 'string' || React.isValidElement(message)) {
      return message;
    } else {
      return Errors.generic;
    }
  };
  return (
    <>
      {message && (
        <StyledTypography
          className={`custom-error ${className} custom-error-${size} custom-error-${styleVariant}`}
          align="center"
        >
          <WarningIcon fontSize="small" />
          {typeof message !== 'string' && console.trace('%c Error :', 'background: pink; color: red', message)}
          {getErrorMessage()}
        </StyledTypography>
      )}
    </>
  );
}

export default CustomError;
